var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings-wrapper"},[_c('h2',{staticClass:"title"},[_vm._v("Carrier Perks")]),_c('div',{staticClass:"content-wrapper"},[_c('carrier-perks')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }